var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPopQuizReplay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9986 2.67665C11.9538 2.67665 11.9091 2.67698 11.8646 2.67754L11.7057 1.00654C11.674 0.673588 11.2712 0.506291 11.0158 0.745494L7.36461 4.16526C7.16806 4.34934 7.19844 4.66874 7.42616 4.81251L11.6563 7.48307C11.9523 7.66987 12.3164 7.42949 12.2847 7.09654L12.1268 5.4367C16.2654 5.50528 19.5851 8.88196 19.5851 13.022C19.5851 17.2122 16.1887 20.6085 11.9985 20.6085C7.80842 20.6085 4.412 17.2122 4.412 13.022H1.65331C1.65331 18.7352 6.28531 23.3672 11.9985 23.3672C17.7118 23.3672 22.3437 18.7352 22.3437 13.022C22.3438 7.30865 17.7118 2.67665 11.9986 2.67665Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPopQuizReplay);
export default __webpack_public_path__ + "static/media/popQuizReplay.e387b0bb8c38cae78cfcfd1c2f05a56e.svg";
export { ForwardRef as ReactComponent };